<template>
  <div>
    <div class="item">
      <label class="lft">工程名称：</label>
      <label class="cnt">{{ data.enginner_name }}</label>
    </div>
    <div class="item">
      <label class="lft">检测项目：</label>
      <label class="cnt">{{ data.test_item }}</label>
    </div>
    <div class="item" style="color: red">
      <label class="lft">费用情况：</label>
      <label class="cnt">{{ data.expenses }}</label>
    </div>
    <div class="item">
      <label class="lft">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</label>
      <label class="cnt">{{ data.customer }}</label>
    </div>
    <div class="item">
      <label class="lft">联系电话：</label>
      <label class="cnt">{{ data.customer_mobile }}</label>
    </div>
    <div class="item">
      <label class="lft">所在地区：</label>
      <label class="cnt"
        >{{ data.province }} {{ data.city }} {{ data.area }}</label
      >
    </div>
    <div class="item">
      <label class="lft">详细地址：</label>
      <label class="cnt">{{ data.address }}</label>
    </div>

    <div class="item">
      <label class="lft">分配检测部门：</label>
      <label class="cnt">
        <el-select
          v-model="selectedDep"
          placeholder="请选择"
          style="width: 100%"
          multiple
        >
          <el-option
            v-for="item in testDepartList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </label>
    </div>

    <div class="item">
      <label class="lft">审批意见：</label>
      <label class="cnt">
        <el-input v-model="data.pass_error"></el-input
      ></label>
    </div>
    <div style="margin-top: 20px">
      <el-button type="primary" style="width: 100%" @click="submitForm()"
        >审批通过</el-button
      >
      <el-button
        type="danger"
        style="width: 100%; margin-top: 15px; margin-left: 0"
        @click="submitFormFalse()"
        >审批不通过</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "task_add",
  components: {},
  data() {
    return {
      testDepartList: [],
      data: {},
      selectedDep: [],
    };
  },
  methods: {
    async showInfo(id) {
      this.testDepartList = await this.$api.request.get(
        "/task/get_testdepartmnet"
      );
      this.data = await this.$api.request.get("/task/get", {
        params: {
          id: id,
        },
      });
      if (this.data.in_testingdepart) {
        this.selectedDep = this.data.in_testingdepart.split(",");
      }
    },
    async submitForm() {
      this.data.in_testingdepart = this.selectedDep.join(",");

      if (!this.data.in_testingdepart) {
        this.$api.error("请选择分配检测部门");
        return;
      }

      await this.$api.confirm("确认审批通过吗？");
      var data = await this.$api.request.post("/task/pass", {
        taskid: this.data.id,
        state: 1,
        testing_depart: this.data.in_testingdepart,
        pass_error: this.data.pass_error,
      });
      this.$api.success("操作成功");
      this.$router.replace("/");
      this.$emit("onPassed", { id: this.data.id });
    },
    async submitFormFalse() {
      await this.$api.confirm("确认审批不通过吗？");
      var data = await this.$api.request.post("/task/pass", {
        taskid: this.data.id,
        type: 0,
        pass_error: this.data.pass_error,
      });
      this.$api.success("操作成功");
      this.$router.replace("/");
      this.$emit("onPassed", { id: this.data.id });
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
}
.item .lft {
  text-align: left;
  min-width: 80px;
}
.item .cnt {
  text-align: left;
}
</style>
